import { Link } from "react-router-dom";

import classes from "./articleCard.scss";

const HCCategoryArticleCard = ({ title, description, link }) => {
  return (
    <Link className={classes.root} to={link}>
      <h2 className={classes.title}>{title}</h2>
      <div className={classes.description}>{description}</div>
    </Link>
  );
};

export default HCCategoryArticleCard;
